export default __webpack_public_path__ + "static/media/app_icon.aa690f5e.svg";